var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("Verifikasi Email")]),_c('v-card-text',[_c('v-alert',{attrs:{"dense":"","border":"left","type":"success"}},[_vm._v(" Email berhasil diverifikasi, silahkan login ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }